/** Sichtbarkeits-Gates für entry.notes im Kalender-EntryBlock.
 *
 *  Minuten- statt Pixel-basiert: Der frühere Pixel-Vergleich (Blockhöhe vs.
 *  minutesToY(90)) verfehlte durch den 1px-Haarlinien-Abzug der Blockhöhe die
 *  Schwelle bei EXAKT 90min um genau 1px — die Notiz-Vorschau erschien je
 *  nach Zoom-Stufe erst ab 92-93min statt ab 1:30 (Ticket Tim). Minuten sind
 *  deterministisch über alle Zoom-Stufen und Fenstergrößen.
 *
 *  Bei Multi-Day-Einträgen zählt das sichtbare Tages-Segment, nicht die
 *  Gesamtdauer — sonst bekäme ein 23:00-01:00-Eintrag im 1h-Segment Notizen
 *  ohne Platz.
 *
 *  Kompakt-Blöcke (Pixel-Zustand, 18-27px) bleiben Sache des Aufrufers: dort
 *  ist nur die zentrierte Titelzeile gelayoutet, Inline-Notizen rutschten im
 *  flex-row-Layout NEBEN den Titel — der EntryBlock gated Inline-Inhalte
 *  zusätzlich mit !compact und zeigt stattdessen das StickyNote-Icon. */

/** Whitespace-only zählt nicht als Notiz (Konsistenz mit entryTooltip). */
export function hasNotes(notes: string | null | undefined): boolean {
  return !!notes?.trim()
}

/** Projektzeile ab exakt 1h Segmentdauer („at least 1h"-Absicht des alten
 *  Pixel-Gates, das 60min um 1px verfehlte). */
export function showProjectLine(segmentMins: number): boolean {
  return segmentMins >= 60
}

/** Ab dieser Segmentdauer werden Notizen inline im Block gerendert. Mit
 *  Projektzeile eine Stufe später, damit kurze Blöcke nicht zulaufen. */
export function showInlineNotes(
  segmentMins: number,
  hasProject: boolean,
  notes: string | null | undefined,
): boolean {
  if (!hasNotes(notes)) return false
  return segmentMins >= (hasProject ? 90 : 60)
}
